
export const COLOR_lukatec_amarelo = "#f4b425"

export const COLOR_full_background_default = '#F2F3F3'; //(--awsui-color-background-layout)
export const COLOR_appbar_background_default = '#8d8d8d';
export const COLOR_drawer_background = '#efefef';

export const COLOR_palette_commom_black = "#000";
export const COLOR_palette_commom_white = "#fff";

export const COLOR_palette_background_paper = "#ffffff";
export const COLOR_palette_background_default = "#bdbdbd";

export const COLOR_palette_primary_light = "#efefef";
export const COLOR_palette_primary_main = "#bdbdbd";
export const COLOR_palette_primary_dark = "#8d8d8d"
export const COLOR_palette_primary_contrastText = "#fff";

export const COLOR_palette_secondary_light = "#ffff81"
export const COLOR_palette_secondary_main =  COLOR_lukatec_amarelo   // "#ffd54f"
export const COLOR_palette_secondary_dark = "#fdbb26"; //"#c8a415"
export const COLOR_palette_secondary_contrastText = "#fff"

export const COLOR_palette_error_light = "#e57373"
export const COLOR_palette_error_main = "#f44336"
export const COLOR_palette_error_dark = "#d32f2f"
export const COLOR_palette_error_contrastText = "#fff"

export const COLOR_palette_text_primary = "#424242"
export const COLOR_palette_text_secondary = "#424242"
export const COLOR_palette_text_disabled = "rgba(0, 0, 0, 0.38)"
export const COLOR_palette_text_hint = "rgba(0, 0, 0, 0.38)"

/////////   Componentes


export const COLOR_expansionPanelHeader = COLOR_palette_secondary_dark;

export const COLOR_text_button_background_primary_default = '#ff9100';    // ##ff9100
export const COLOR_content_background_layout_default = '#f2f3f3';
export const COLOR_text_base = '#16191f';                                   //  var(--awsui-color-text-base)
export const COLOR_text_nav_selected = '#ec7211';                    // var(--awsui-color-text-nav-selected)


export const COLOR_chart_barra_serie_0 = COLOR_palette_secondary_dark;

export const COLOR_chart_barra_utilizacao_serie_0 = COLOR_lukatec_amarelo; //COLOR_palette_secondary_dark;
export const COLOR_chart_barra_utilizacao_serie_1 = COLOR_lukatec_amarelo; //COLOR_palette_secondary_dark;

export const COLOR_chart_barra_ritmo_serie_0 = COLOR_lukatec_amarelo; // COLOR_palette_secondary_dark;
export const COLOR_chart_barra_ritmo_serie_1 = "#91c1ef";
export const COLOR_chart_barra_ritmo_serie_2 = "#8d8d8d";

export const COLOR_chart_barra_horas_serie_0 = COLOR_lukatec_amarelo; //COLOR_palette_secondary_dark;
export const COLOR_chart_barra_horas_serie_1 = "#91c1ef";
export const COLOR_chart_barra_horas_serie_2 = "#8d8d8d";



// 1F77B4 3E88BB
export const COLOR_chart_series_first_line = '#1F77B4';

export const COLOR_shadow_medium = 'rgba(0,28,36,0.3)';
export const COLOR_shadow_side  = 'rgba(0,28,36,0.15)';


//testes azul para grafico
// #3E88BB
// #257BB6
